import {FetchedCampaign} from '@analytics/graphql-api';
import _CampaignStatsBase from './_CampaignStatsBase';

export const CampaignStats = ({campaign}: {campaign: FetchedCampaign}) => {
  return <_CampaignStatsBase instance={campaign} campaign={campaign} />;
};
